import React from 'react';

import NavBar from '../components/NavBar';
import SingleBlog from '../components/SingleBlog';

const SinglePost = () => {
    return (
        <div>
            <NavBar />
            <SingleBlog />
        </div>
    )
}


export default SinglePost